export class QueryComments {
  queryid: number;
  query: string;
  parent: number; 
  active: number;
  createdby: number;
  createdon: string;
  modifiedby: number;
  modifiedon: string;
  createdbyname: string;
  requestdetailid: number;
  requesttypeid: number;
  type: string;
  replycomments: any;


}
